import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	static targets = [
		"halfCard",
		"fullCard",
		"planTypeField",
		"halfPriceDisplay",
		"fullPriceDisplay",
		"halfOnly",
		"fullOnly",
	];

	static values = {
		dogId: String,
		subscriptionId: String,
	};

	connect() {
		this.currentPlanType = this.planTypeFieldTargets[0]?.value || "full";

		this.trackEvent("half_plan_default_shown", {
			default_plan_type: this.currentPlanType,
		});
	}

	selectHalf() {
		if (this.currentPlanType === "half") return;

		const previousPlanType = this.currentPlanType;
		this.currentPlanType = "half";

		this._applySelection("half");

		this.trackEvent("half_plan_selected", {
			plan_type: "half",
			previous_plan_type: previousPlanType,
		});
	}

	selectFull() {
		if (this.currentPlanType === "full") return;

		const previousPlanType = this.currentPlanType;
		this.currentPlanType = "full";

		this._applySelection("full");

		this.trackEvent("half_plan_selected", {
			plan_type: "full",
			previous_plan_type: previousPlanType,
		});
	}

	// Card state, hidden field, price blocks and any fullOnly/halfOnly content
	// move together. The card targets span BOTH selectors (hero + pinned bar), so
	// each selection syncs both.
	_applySelection(planType) {
		const isHalf = planType === "half";

		this._setCardState(this.halfCardTargets, isHalf);
		this._setCardState(this.fullCardTargets, !isHalf);

		this.planTypeFieldTargets.forEach((el) => { el.value = planType; });

		this._setHidden(this.halfPriceDisplayTargets, !isHalf);
		this._setHidden(this.fullPriceDisplayTargets, isHalf);
		this._setHidden(this.halfOnlyTargets, !isHalf);
		this._setHidden(this.fullOnlyTargets, isHalf);
	}

	_setCardState(cards, selected) {
		cards.forEach((el) => {
			el.classList.toggle("m-review-plan-card--active", selected);
			el.setAttribute("aria-pressed", selected ? "true" : "false");
		});
	}

	_setHidden(elements, hidden) {
		elements.forEach((el) => el.classList.toggle("d-none", hidden));
	}

	trackEvent(eventName, properties = {}) {
		if (window.posthog && typeof window.posthog.capture === "function") {
			window.posthog.capture(eventName, {
				...properties,
				dog_id: this.hasDogIdValue ? this.dogIdValue : undefined,
				subscription_id: this.hasSubscriptionIdValue ? this.subscriptionIdValue : undefined,
			});
		}
	}
}
